// extracted by mini-css-extract-plugin
module.exports = {"siderWrapper":"siderWrapper--3jZkz","bottomMenu":"bottomMenu--2RyOV","userMenu":"userMenu--2tRVu"};